// extracted by mini-css-extract-plugin
module.exports = {"CheckoutWrapper":"Checkout_CheckoutWrapper__2R8Gr","CheckoutLeftColumn":"Checkout_CheckoutLeftColumn__1vlhH","CheckoutRightColumn":"Checkout_CheckoutRightColumn__1lEHp"};